var _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorInteriorDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.166,16.344l-2.593-2.408c-2.485-2.307-3.179-5.926-1.8-8.964h-7.546c1.379,3.038.684,6.656-1.8,8.964l-2.593,2.408c-5.399,5.014-4.94,13.693.958,18.108l1.676,1.255-1.045,1.967c-.28.527.102,1.162.699,1.162h11.756c.597,0,.978-.635.699-1.162l-1.045-1.967,1.676-1.255c5.898-4.416,6.357-13.095.958-18.108Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.147,
    y: 3.164,
    width: 11.751,
    height: 1.808,
    rx: 0.904,
    ry: 0.904
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.547,35.681c-1.705,1.073-3.58.639-5.547.639s-3.826.439-5.525-.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.61,22.788l.839.31c6.489,2.394,14.662,2.389,21.143-.014l.799-.296"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.61,25.969l.839.31c6.489,2.394,14.662,2.389,21.143-.014l.799-.296"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorInteriorDecoration);
export default __webpack_public_path__ + "static/media/indoor-interior_decoration.6f358307607f3fa31cf6d40081260641.svg";
export { ForwardRef as ReactComponent };